import Moment from "moment";

export function calculateCalendarDuration(startMoment:Moment|null, endMoment:Moment|null) : number | null {

    if (!startMoment) return null

    if (!endMoment) return 1 // calendar 1 day event case


    return Math.abs(endMoment.diff(startMoment,'days')) + 1

}